/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_All_ToolsInputs */

const en_directory_nav_all_tools = /** @type {(inputs: Directory_Nav_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Tools`)
};

const zh_directory_nav_all_tools = /** @type {(inputs: Directory_Nav_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部工具`)
};

/**
* | output |
* | --- |
* | "All Tools" |
*
* @param {Directory_Nav_All_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_all_tools = /** @type {((inputs?: Directory_Nav_All_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_All_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_all_tools(inputs)
	return zh_directory_nav_all_tools(inputs)
});
export { directory_nav_all_tools as "directory.nav.all_tools" }